import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import '../../../static/css/pages/parents/tuition/tuition.css';
import {CurrencyFormat, NumberToPersianLetters} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {useNavigate} from "react-router-dom";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const PayTuitionModal = (props: {
    active: boolean,
    closeHandler: any,
    totalPrice: number,
    paidSoFar: number,
    suggestedPrice: number,
    min:number,
}) => {
    const [price, setPrice] = useState('1000000');
    const [priceErr, setPriceErr] = useState(''); // error message in persian, '' => no errors
    const priceId = useId();
    const navigate = useNavigate();
    useEffect(() => {
        const isActive = props.active;
        const suggested = props.suggestedPrice;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setPrice(suggested === 0 ? '' : suggested.toString());
            setPriceErr('');
        } else {
            document.body.classList.remove("body-no-scroll");
        }
    }, [props.active]);
    const generateInvoice = () => {
        const _price = price;
        if(_price === '' || _price === 'NaN'){
            setPriceErr('لطفا مبلغ را وارد کنید.');
            return;
        }
        const priceInt = parseInt(_price);
        if((priceInt+props.paidSoFar) > props.totalPrice){
            setPriceErr('مبلغ وارد شده بیش از شهریه تعیین شده است.');
            return;
        }
        if(priceInt < props.min){
            setPriceErr(`حداقل مبلغ پرداختی ${CurrencyFormat(props.min)} تومان می‌باشد.`);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/tuition/generate-invoice',
            {p:priceInt.toString()},
            true,
            (d:{
                result:string,
                reason:string|undefined,
                nd:string,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                ShowSnackbar('لطفا فاکتور ایجاد شده را پرداخت کنید.','باشه',5000);
                navigate(`/students/tuition/pay/${d.nd}`);
            },
            ()=>{
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div>
                        <b>پرداخت قسط شهریه</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="pay-tuition-modal">
                        <label htmlFor={priceId}>مبلغی که می‌خواهید پرداخت کنید:</label>
                        <input type="number"
                               className={"form-control text-center" + (priceErr === '' ? '' : ' is-invalid')}
                               value={price}
                               min={props.min}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setPrice(t);
                                   setPriceErr('');
                               }}
                               onKeyUp={e => {
                                   if (e.which === 13)
                                       generateInvoice();
                               }}
                        />
                        {
                            price !== '' ?
                                <span style={{
                                    display: 'block',
                                    margin: '5px 0 0 0',
                                    fontWeight: 400,
                                    color: '#0a53be'
                                }}>
                                       {NumberToPersianLetters(parseInt(price)) + " تومان"}
                                   </span> : null
                        }
                        <div className={"invalid-feedback " + (priceErr === '' ? 'd-none' : 'd-block')}>{priceErr}</div>
                        <div className="d-flex justify-content-end align-items-center"
                             style={{gap: 10, marginTop: 30}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={generateInvoice}>
                                <b>ادامه پرداخت</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};